import { render } from 'preact';
import { FormContainer } from './container/FormContainer';


const App = () => <FormContainer />

render(<App />, document.getElementById('mail-box-news'));
//  export default App;
